import useCopilotPatientsList from 'components/CopilotControl/hooks/useCopilotPatientsList'
import _ from 'lodash'
import React, { useCallback, useMemo } from 'react'
import { useFetchOralHygienePatientsInfiniteQuery } from 'store/modules/OralHygieneReport'
import PatientsListError from '../../components/CopilotPatientsLists/PatientsListError'
import PatientsSentimentHeaderSkeleton from '../../components/CopilotPatientsLists/PatientsSentimentList/PatientsSentimentHeaderSkeleton'
import PatientsList from '../../components/common/PatientsList/PatientsList'
import { getOralHygieneCategoryCounts } from '../oralHygieneReportLogic'
import OralHygieneEmptyState from './OralHygieneEmptyState'
import OralHygieneListHeader from './OralHygieneListHeader'
import OralHygienePatientListItem from './OralHygienePatientListItem'

const OralHygienePatientsList = ({
  accountOwnerId,
  listType,
  onListTypeSelected,
  selectedCategories,
  setSelectedCategories,
  pastXDays,
  aggregationData,
  isAggregationLoading
}) => {
  const { isStatusesLoading } = useCopilotPatientsList()

  const {
    data: patients = [],
    isLoading,
    isFetching,
    isFetchingNextPage,
    isError,
    fetchNextPage
  } = useFetchOralHygienePatientsInfiniteQuery(
    {
      accountOwnerId,
      listType,
      categories: selectedCategories,
      pastXDays
    },
    {
      skip: !accountOwnerId
    }
  )

  // Chip counts are the complete category totals of the selected period; row filtering never changes them.
  const categoryCounts = useMemo(
    () => getOralHygieneCategoryCounts(aggregationData, listType),
    [aggregationData, listType]
  )

  const patientsPaginatedData = useMemo(() => {
    return patients.pages?.map(page => page.items).flat() || []
  }, [patients])

  const hasMorePages = _.last(patients?.pages || [])?.hasMore
  const isListLoading = isLoading || isStatusesLoading || isFetching

  const PatientListItemComponent = useCallback(
    props => <OralHygienePatientListItem {...props} listType={listType} pastXDays={pastXDays} />,
    [listType, pastXDays]
  )

  return (
    <PatientsList
      isHeaderLoading={isAggregationLoading}
      isListLoading={isListLoading && !isFetchingNextPage}
      isEmpty={false}
      fetchNextPage={fetchNextPage}
      hasMorePages={hasMorePages}
      patients={patientsPaginatedData}
      EmptyStateComponent={isError ? <PatientsListError /> : <OralHygieneEmptyState />}
      HeaderSkeletonComponent={<PatientsSentimentHeaderSkeleton />}
      PatientsHeaderComponent={
        <OralHygieneListHeader
          listType={listType}
          onListTypeSelected={onListTypeSelected}
          categoryCounts={categoryCounts}
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
          pastXDays={pastXDays}
        />
      }
      PatientListItemComponent={PatientListItemComponent}
    />
  )
}

export default OralHygienePatientsList
